import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";

export const ReclasificacionApi = () => {
    const [cargando, setCargando] = useState(false);

    const getInventariosReclasificacion = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(`reclasificacion`, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getInventariosReclasificacion,

        cargando,
    };
};
